export const defaultTranslations = {
  general: {
    draft: 'Draft',
    somethingWentWrong: 'Something went wrong',
  },
};
